@if(doShowModal){
    <div class="attachment-view-container">
        @if (isLoading || isLoadingPDF) {
            <app-loading-indicator />
        } 
        @else{
            <div class="attachment-body">
                <button class="button-cancel float-right" type="button" [disabled]="isLoading" (click)="hideModal()">Close</button>
                @if(canDelete){
                    <button class="button-delete float-right" type="button" style="margin-right: 15px;" [disabled]="isLoading" (click)="deleteFile()">Delete</button>
                }
                <div class="attachment-content d-flex flex-column align-items-center justify-content-center">
                    @if(isPDF) {
                        <div class="att-view-box">
                            <ng2-pdfjs-viewer [pdfSrc]="securePdfUrl ?? ''" [print]="false"
                            [download]="false"
                            [fullScreen]="false"
                            [viewBookmark]="false"
                            [openFile]="false"></ng2-pdfjs-viewer>                           
                        </div>
                    }
                    @else {
                        <div class="image-viewer">
                            <div class="image-viewer__toolbar" aria-label="Image controls">
                                <button type="button" class="button-cancel image-viewer__button" (click)="zoomOut()" [disabled]="imageZoom <= minImageZoom">-</button>
                                <span class="image-viewer__zoom">{{ imageZoom | percent:'1.0-0' }}</span>
                                <button type="button" class="button-cancel image-viewer__button" (click)="zoomIn()" [disabled]="imageZoom >= maxImageZoom">+</button>
                                <button type="button" class="button-cancel image-viewer__button" (click)="resetImageView()">Fit</button>
                            </div>
                            <div
                                class="image-viewer__stage"
                                [class.image-viewer__stage--pan-enabled]="imageZoom > minImageZoom"
                                [class.image-viewer__stage--panning]="isPanningImage"
                                (wheel)="onImageWheel($event)"
                                (pointerdown)="startImagePan($event)"
                                (pointermove)="panImage($event)"
                                (pointerup)="endImagePan($event)"
                                (pointercancel)="endImagePan($event)"
                                (dblclick)="resetImageView()"
                            >
                                <img
                                    class="image-viewer__image"
                                    [src]="attachment?.URL"
                                    [alt]="attachment?.FileName ?? 'Attachment image'"
                                    [style.transform]="imageTransform"
                                    draggable="false"
                                >
                            </div>
                        </div>
                    }
                    <div class="attachment-file-name">
                        <em><span>{{attachment?.FileName}}</span></em>
                    </div>
                </div>
            </div>
        }
    </div>
}